/*==========================================================
HTML CLASSES SCRIPT
==========================================================*/

function screenSizeClasses() {
    if (Modernizr.mq('only screen and (min-width: 992px)')) {
        $('html').removeClass('mobile').removeClass('tablet').addClass('desktop');
    }

    if (Modernizr.mq('only screen and (max-width: 991px)') && (Modernizr.touch) || Modernizr.mq('only all and (max-width: 991px)')) {
        $('html').removeClass('mobile').removeClass('desktop').addClass('tablet');
    }

    if (Modernizr.mq('only screen and (max-width: 767px)')) {
        $('html').removeClass('tablet').removeClass('desktop').addClass('mobile');
        document.addEventListener("touchstart", function() {}, true) // ADD 'ACTIVE' STATE TO TOUCH LINKS
    }
}

$(window).load(function() {
    screenSizeClasses();
    $('body').addClass('loaded');
});

//debounce resize instead of standard resize
$(window).debounceResize(function() {
    screenSizeClasses();
});

$(function() {
    screenSizeClasses();
   
    if (!Modernizr.objectfit) {
        $('body').addClass('no-objectfit');
    }
});